import {
  FirestoreCollections,
  FirestoreSubcollections,
  ID,
} from '@griply/types';

import { FirestoreInstance } from '../types/firestore';

export const EXTERNAL_CONNECTION_CALENDARS_DOC = 'calendars';

export type GetExternalConnectionCalendarsDocOptions<
  TDocRef = unknown,
  TDb = FirestoreInstance,
> = {
  externalConnectionId: ID;
  db: TDb;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
};

export const getExternalConnectionCalendarsDoc = <
  TDocRef,
  TDb = FirestoreInstance,
>(
  options: GetExternalConnectionCalendarsDocOptions<TDocRef, TDb>,
): TDocRef => {
  const { externalConnectionId, db, doc } = options;
  return doc(
    db,
    FirestoreCollections.ExternalConnections,
    externalConnectionId,
    FirestoreSubcollections.Runtime,
    EXTERNAL_CONNECTION_CALENDARS_DOC,
  );
};
